export interface Phase {
  id: string;
  order: number;
  code?: string;
  name: string;
  color: string;
  masterPhaseIds: string[];
  linkedPhaseIds?: string[];
  linkedPhases?: PhaseLink[];
}

export interface PhaseLink {
  constructionAreaId: string;
  phaseId: string;
  linkedPhaseIds?: string[];
  previousPhaseIds?: string[];
  startDate?: Date;
  endDate?: Date;
  durationDays?: number;
}

export const phaseChatbotFields = {
  id: { type: 'string', description: 'Must be specified for update or delete.' },
  code: { type: 'string', description: 'Optional. Short phase code, e.g. "P1".' },
  name: {
    type: 'string',
    description: 'Must be specified for new entries. Otherwise should be only set if the intend it to change it.',
  },
  order: { type: 'number', description: 'Optional. Describes the order in the list.' },
  masterPhaseIds: {
    type: 'array',
    description: 'Optional. Master project phase ids linked to this phase. Set [] to remove master links.',
    items: { type: 'string' },
  },
};
